<div class="network-indicator">
  <mat-icon
    *ngIf="pusherStatus$ | async as pusherStatus"
    svgIcon="cm:cloud-sync"
    [ngClass]="pusherStatus === 'connected' ? 'success' : 'error'"
  ></mat-icon>
</div>
